// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as VehicleListCmp from "../../components/VehicleListCmp.bs.js";
import * as GeoRegionListCmp from "../../components/GeoRegionListCmp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getViewModel(state, campaign) {
  var geo_regions = state.geo_regions;
  var tmp;
  if (typeof geo_regions === "number" || geo_regions.TAG !== /* Live */1) {
    tmp = ErrorUtils$Catalyst.raiseError("FilterAllocationDashboardListVMMapper", "Dead state", "");
  } else {
    var found_geo_region = GeoRegionListCmp.getGeoRegionFromId(campaign.geo_region_id, geo_regions._0);
    tmp = found_geo_region !== undefined ? ({
          name: found_geo_region.name,
          id: found_geo_region.id
        }) : ErrorUtils$Catalyst.raiseError("FilterAllocationDashboardListVMMapper", "Selected geo region not found", "");
  }
  var vehicles = state.vehicles;
  var tmp$1;
  if (typeof vehicles === "number" || vehicles.TAG !== /* Live */1) {
    tmp$1 = ErrorUtils$Catalyst.raiseError("FilterAllocationDashboardListVMMapper", "Dead state", "");
  } else {
    var found_vehicle = VehicleListCmp.getVehicleFromId(campaign.vehicle_id, vehicles._0);
    tmp$1 = found_vehicle !== undefined ? ({
          vehicle_id: found_vehicle.vehicle_id,
          vehicle: {
            vehicle_type: found_vehicle.vehicle.vehicle_type,
            display_name: found_vehicle.vehicle.display_name
          }
        }) : ErrorUtils$Catalyst.raiseError("FilterAllocationDashboardListVMMapper", "Selected vehicle not found", "");
  }
  var name = campaign.name;
  var tmp$2;
  if (name !== undefined) {
    tmp$2 = name;
  } else {
    var match = state.selected_geo_region;
    var match$1 = state.selected_vehicle;
    tmp$2 = match !== undefined && match$1 !== undefined ? match.name + "-" + match$1.vehicle.vehicle_type : ErrorUtils$Catalyst.raiseError("FilterAllocationDashboardListVMMapper", "Selected vehicle or geo region not found", "");
  }
  var zones = campaign.zones;
  var clusters = campaign.clusters;
  var data = campaign.creator_info;
  var approver = campaign.approver_info;
  return {
          geo_region: tmp,
          vehicle: tmp$1,
          name: tmp$2,
          id: campaign.id,
          campaign_status: campaign.campaign_status,
          effective_from: campaign.effective_from,
          effective_till: campaign.effective_till,
          filters: {
            allocation_radius: {
              auto: campaign.filters.allocation_radius.auto,
              manual: campaign.filters.allocation_radius.manual
            },
            dry_run: {
              threshold: campaign.filters.dry_run.threshold,
              ratio: campaign.filters.dry_run.ratio
            },
            maps_distance: {
              manual: campaign.filters.maps_distance.manual,
              auto: campaign.filters.maps_distance.auto
            }
          },
          zones: zones !== undefined ? List.map((function (zone) {
                    return {
                            name: zone.name,
                            id: zone.id
                          };
                  }), zones) : /* [] */0,
          clusters: clusters !== undefined ? List.map((function (cluster) {
                    return {
                            name: cluster.name,
                            id: cluster.id
                          };
                  }), clusters) : /* [] */0,
          creator_info: data !== undefined ? ({
                created_by: {
                  name: data.created_by.name,
                  email_id: data.created_by.email_id
                },
                created_on: data.created_on
              }) : undefined,
          approver_info: approver !== undefined ? ({
                approved_by: {
                  name: approver.approved_by.name,
                  email_id: approver.approved_by.email_id
                },
                approved_on: approver.approved_on
              }) : undefined
        };
}

var VMMapper = {
  getViewModel: getViewModel
};

export {
  VMMapper ,
  
}
/* VehicleListCmp Not a pure module */
